import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface DefaultFlagButtonProps {
  is_default: boolean;
  onReflect: () => void;
}
function DefaultFlagButton({ is_default, onReflect }: DefaultFlagButtonProps) {
  const { t } = useTranslation();
  const buttonText = `${t('EatingWayTimeFrameModal.default_flg_button')}<br/>${t(
    'EatingWayTimeFrameModal.default_flg_button1'
  )}<br/>${
    is_default
      ? t('EatingWayTimeFrameModal.default_flg_button_show')
      : t('EatingWayTimeFrameModal.default_flg_button_hide')
  }`;
  return (
    <Button
      style={{ position: 'absolute', top: '10px', right: '10px', minWidth: '80px', minHeight: '65px' }}
      className={is_default ? 'btn--orange' : 'btn--white'}
      dangerouslySetInnerHTML={{ __html: buttonText }}
      onClick={(event) => {
        event.stopPropagation();
        onReflect();
      }}
    ></Button>
  );
}
export default DefaultFlagButton;
